var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var rebillyConfigs = new Map();
var baseLiveConfig = {
    stage: 'live',
    rebillyUri: 'https://api.rebilly.com/v2.1',
    serverUri: 'https://prod.coinapp.co/checkout',
    publicKey: 'pk_live_Mpb2Z80I1GVoF334i64_8RtgYEczLyvkk7zJ0KR',
    organizationId: 'd3fbb7ce-c0fb-494b-b7f2-c8987d28f043',
    websiteId: '2c17b430-d331-4650-a755-3736e58359ed',
};
var baseSandboxConfig = {
    stage: 'sandbox',
    rebillyUri: 'https://api-sandbox.rebilly.com/v2.1',
    serverUri: 'https://prod.coinapp.co/checkout',
    publicKey: 'pk_sandbox_uSCFz8SZ9mExc-kc9rQvMNSo9TycKuS0PtOHoyO',
    organizationId: 'd3fbb7ce-c0fb-494b-b7f2-c8987d28f043',
    websiteId: 'xyo-network',
};
rebillyConfigs.set('live', baseLiveConfig);
rebillyConfigs.set('sandbox', baseSandboxConfig);
rebillyConfigs.set('dev', __assign(__assign({}, baseSandboxConfig), { serverUri: 'https://dev-checkout-apollo.xy.company' }));
rebillyConfigs.set('local', __assign(__assign({}, baseSandboxConfig), { serverUri: 'http://localhost:8082' }));
//# sourceMappingURL=rebilly.js.map